export default __webpack_public_path__ + "static/media/ellipseIcon.c789176b.svg";